import type { FC } from 'react';

import BackButton from 'components/BackButton';
import { StepProps } from 'components/Stepper/types';
import * as routes from 'features/BankTransferRequests/routes';
import * as Layout from 'layouts/StickyStepperLayout';

import { useBankTransferRequestsNewState } from '../../../BankTransferRequestsNewProvider';
import RecipientInformationForm from './components/RecipientInformationForm';

const RecipientInformation: FC<StepProps> = ({ goNext }) => {
  const { dispatch, recipientInformation } = useBankTransferRequestsNewState();

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton to={routes.root} />
        </Layout.HeaderButtonsContainer>
        <RecipientInformationForm
          defaultValues={recipientInformation}
          onSubmit={(data) => {
            dispatch({
              payload: data,
              type: 'SUBMIT_RECIPIENT_INFORMATION',
            });
            goNext({
              key: 'transfer-information',
            });
          }}
        />
      </Layout.Body>
    </Layout.Root>
  );
};

export default RecipientInformation;
